import axios, {
  InternalAxiosRequestConfig,
  AxiosResponse,
  AxiosError,
} from "axios";
import GlobalSharedStateClass from "../util/globalSharedStateClass";

const initialization = () => {
  const api = axios.create({
    baseURL: import.meta.env.VITE_MY_PAPERFLOW_API_URL,
    timeout: 180000,
  });

  const State = new GlobalSharedStateClass();
  const searchParams = new URLSearchParams(document.location.search);
  const hasUrlToken = !!searchParams.get("token");
  let token = searchParams.get("token") || localStorage.getItem("token");

  if (hasUrlToken) {
    State.setHasTokenInUrl(true);
  }

  if (searchParams.get("token")) {
    localStorage.removeItem("selected-organization");
  }

  const handleInterceptRequest = (config: InternalAxiosRequestConfig) => {
    token = token
      ? token
      : searchParams.get("token") || localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  };

  const onResponseError = (error: AxiosError) => {
    if (401 === error?.response?.status) {
      localStorage.removeItem("token");

      if (hasUrlToken) {
        const element = document.createElement("div");
        element.id = "unauthorized";
        element.classList.add("unauthorized-block");
        element.innerHTML =
          "<p>The session has expired, please close this window</p>";
        document.querySelector("body")?.appendChild(element);
      } else {
        // @ts-ignore
        window.location = "/login";
      }
    } else {
      return Promise.reject(error);
    }
  };

  api.interceptors.request.use(handleInterceptRequest);

  api.interceptors.response.use((response: AxiosResponse) => {
    return response;
  }, onResponseError);

  return api;
};

const api = initialization();

export default api;
